import React, { useState, createContext, useContext, useEffect } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import * as Sentry from "@sentry/react";

// Add Google login
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

const AuthContext = createContext();

const createSession = async (credential, setShowLoginDialog, login) => {
   
    try {
        const res = await fetch(`${BACKEND_HOST}/auth/google`, {
            headers: { "Content-Type": "application/json" },
            method: "POST",
            body: JSON.stringify({ access_token: credential })
        });
        if (!res.ok) throw new Error("Google authentication failed");
        const data = await res.json();
        login(data.user, data.jwt)
        setShowLoginDialog(false);
    } catch (err) {
        console.debug(err.message)
        alert("Google authentication failed.");
    }
};

const LoginDialog = () =>  {
    const {showLoginDialog, setShowLoginDialog, login} = useAuth()

    // const location = useLocation();
     return <Dialog open={showLoginDialog} style={{width: "100vw", backgroundColor:"white", padding:"20px"}}>
            <Paper style={{backgroundColor: "white", padding: "20px"}}>
                <Button style={{color:"black", float:"right"}} onClick={(e) => {setShowLoginDialog(false);e.stopPropagation();}}><CloseIcon />close</Button>
                <h4 style={{color: "darkgrey"}}>Sign in with Google</h4>
                <GoogleLogin
                    ux_mode={"popup"}
                    onSuccess={credentialResponse => createSession(credentialResponse.credential, setShowLoginDialog, login)}
                    onError={() => {
                        console.log('Login Failed');
                    }}
                />
                <h4 style={{color: "darkgrey"}}>Is this safe?</h4>
                <p style={{color: "black"}}>Yes, Google logins are safe to use. Using Google to sign in will share your name, email and profile pic with this app.</p>
                <p style={{color: "black"}}>Your information is only used to make this app function and will not be used for marketing purposes.</p>
                <p style={{color: "black"}}>For more information check out the <Button variant={"contained"} href={"/privacy"} size={"small"}>PRIVACY POLICY PAGE</Button></p>
            </Paper>
        </Dialog>
}
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const storedUser = window.localStorage.getItem("authUser");
        return storedUser ? JSON.parse(storedUser) : null;
    });
    const [token, setToken] = useState(() => window.localStorage.getItem("authToken"));
    const [loggedIn, setLoggedIn] = useState(() => user && token);
    const [currentUserProfile, setCurrentUserProfile] = useState(null);
    const [hasUserProfile, setHasUserProfile] = useState(false);
    const [profilePromptOpen, setProfilePromptOpen] = useState(false);
    const [profilePromptAck, setProfilePromptAck] = useState(null);
    const [profilePromptToken, setProfilePromptToken] = useState(null);
    const [showLoginDialog, setShowLoginDialog] = useState(false)
    const [feedback, setFeedback] = useState({ message: "", color: "success" });

    const login = async (userData, authToken) => {
        
        setUser(userData);
        setToken(authToken);
        setLoggedIn(!!userData && !!authToken);
        window.localStorage.setItem("authUser", JSON.stringify(userData));
        window.localStorage.setItem("authToken", authToken);

        try {
            const res = await fetch(`${BACKEND_HOST}/user-acks/mine`, {
                headers: {
                    "Authorization": `Bearer ${authToken}`,
                    "Content-Type": "application/json"
                }
            });
            if (res.ok) {
                const data = await res.json();
                const ack = Array.isArray(data) ? data.find(a => a.key === "signup-create-profile") :
                    (data.data || []).find(a => a.attributes?.key === "signup-create-profile");
                if (ack) {
                    setProfilePromptAck(ack);
                    setProfilePromptToken(authToken);
                    setProfilePromptOpen(true);
                    return;
                }
            }
        } catch (err) {
            window.location = "/";
            return;
        }
        window.location = "/";
    };

    // Handler for dialog actions
    const handleProfilePrompt = async (makeProfile) => {
        setProfilePromptOpen(false);
        if (profilePromptAck && profilePromptToken) {
            await fetch(`${BACKEND_HOST}/user-acks/${profilePromptAck.documentId}`, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${profilePromptToken}`,
                    "Content-Type": "application/json"
                }
            });
            if (makeProfile) {
                window.location = "/account?createProfile=1";
            } else {
                window.location = "/";
            }
        } else {
            window.location = "/";
        }
    };

    const logout = () => {
        setUser(null);
        setToken(null);
        setLoggedIn(false);
        window.localStorage.removeItem("authUser");
        window.localStorage.removeItem("authToken");
    };

    

    // Add getCurrentUser function
    const getCurrentUser = async () => {
        const token = window.localStorage.getItem("authToken");
        if (!token) return null;
        try {
            const res = await fetch(`${BACKEND_HOST}/users/me?populate=*`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            })
            if (!res.ok) {
                logout();
            }
            
            setUser(await res.json())
        } catch (err) {
            Sentry.captureException(err)
            logout();
        }
    };

    const loadCurrentUserProfile = async () => {
        const token = window.localStorage.getItem("authToken");
        if (!token) return null;
        fetch(`${BACKEND_HOST}/user-profiles/mine`, {
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            }
        })
        .then(res => res.json())
        .then(obj => { 
            console.log("Loaded current user profile:", obj);
            setCurrentUserProfile(obj.hasOwnProperty("documentId") ? obj : null);
            setHasUserProfile(obj.hasOwnProperty("documentId") ? 1 : 0);
          
        })
        .catch(err => {
            setCurrentUserProfile(null);
            setHasUserProfile(false);
        });
    };

    useEffect(() => {
        loadCurrentUserProfile();
         getCurrentUser();
    }, []);

    return (
            <AuthContext.Provider value={{ user, token, login, logout, loggedIn, setUser, setToken, feedback, setFeedback, setLoggedIn, currentUserProfile, hasUserProfile, loadCurrentUserProfile, showLoginDialog, setShowLoginDialog }}>
                <GoogleOAuthProvider clientId="78262272063-k29amnt556dhpfupeepf2ng795278e03.apps.googleusercontent.com">
                {children}
                <LoginDialog showLoginDialog={showLoginDialog} setShowLoginDialog={setShowLoginDialog} />
                <Dialog open={profilePromptOpen} onClose={() => handleProfilePrompt(false)}>
                    <DialogTitle>Create Public Profile?</DialogTitle>
                    <DialogContent>
                        Would you like to create a public profile? This lets others see your name and Instagram.
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleProfilePrompt(false)} color="primary">
                            Not Now
                        </Button>
                        <Button onClick={() => handleProfilePrompt(true)} color="primary" variant="contained">
                            Yes, Create Profile
                        </Button>
                    </DialogActions>
                </Dialog>
            </GoogleOAuthProvider>
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

// Main Authentication Component
const AuthPage = () => {
    const { user } = useAuth();
    return user ? (
        <div>Already logged in</div>
    ) : (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-header">
                    <h1>Sign In</h1>
                    <p>Sign in with your Google account</p>
                </div>
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    <div id="google-signin-btn" style={{ width: "100%" }} />
                </Box>
            </div>
        </div>
    );
};

export default AuthPage;